import React from 'react'
import LogosContainer from "app/react/components/logos/LogosContainer";
import LogosContent from "app/react/components/logos/LogosContent";

export default function LogosOverview (props) {
  return (
    <LogosContainer {...props}>
      <LogosContent/>
    </LogosContainer>
  )
}